"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
exports.builder = {
    withPattern: (pattern, errorMessage) => ({
        type: 'matches',
        pattern,
        errorMessage,
    }),
};
//# sourceMappingURL=MatchesRuleBuilder.js.map